import React from 'react'

import highlightedText from '../../../../utils/highlightedText/highlightedText'

export type LocationLinkProps = {
  id: string
  label: string
  hovered: boolean
  textToHighlight?: string
  onMouseOver: (location: string) => void
  onClick: (locationId: string, locationLabel: string) => void
}

const LocationLink: React.FunctionComponent<LocationLinkProps> = ({
  id,
  label,
  hovered,
  textToHighlight,
  onMouseOver,
  onClick,
}: LocationLinkProps) => {
  const styles = hovered ? { backgroundColor: '#2a7cca', color: '#fff' } : {}
  return (
    <li
      translate='no'
      role='option'
      className='padding-horizontal padding-vertical-s cursor-pointer'
      onMouseOver={() => onMouseOver(id)}
      onClick={() => onClick(id, label)}
      style={styles}
    >
      {id === '0' ? <span className='font-highlight'>{label}</span> : highlightedText(label, textToHighlight)}
    </li>
  )
}

export default LocationLink
